import { useQuery, useQueryClient } from '@tanstack/react-query'
import _ from 'lodash'

export default function useGetVault({ vaultId } = {}) {
  const queryClient = useQueryClient()

  const fetchData = async () => {
    const data = queryClient.getQueriesData({
      queryKey: ['vaults', 'list'],
      //   type: 'active',
    })

    const vaultsQuery = data ? data[data.length - 1] : []
    const [, vaults] = vaultsQuery

    const result = _.flatten(
      vaults?.map((vault) => {
        return vault.is_group ? vault.vaults : [vault]
      }),
    )?.find((x) => x.id === Number(vaultId))

    return result
  }

  return useQuery({
    queryKey: ['vaults', { id: vaultId }],
    queryFn: fetchData,
  })
}
